<template>
  <div class="casino-demo-wrapper owl-theme owl-carousel" ref="owlCarousel">
    <GameCard v-for="item in items" :key="item.id" :game="item" />
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, watch, nextTick } from "vue";
import "owl.carousel";
import $ from "jquery";
import GameCard from "@/components/partials/GameCard.vue";

export default {
  name: "MostCommentedCarousel",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  components: {
    GameCard,
  },
  setup(props) {
    const owlCarousel = ref(null);

    const destroyCarousel = () => {
      if (owlCarousel.value && $(owlCarousel.value).hasClass("owl-loaded")) {
        $(owlCarousel.value).trigger("destroy.owl.carousel");
        $(owlCarousel.value).removeClass('owl-loaded owl-hidden');
      }
    };

    const initializeCarousel = () => {
      // Destroy and reinitialize the carousel if it's already initialized
      destroyCarousel();

      $(owlCarousel.value).owlCarousel({
        loop: true,
        margin: 10,
        smartSpeed: 2500,
        autoplayTimeout: 3000,
        autoplay: false,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: $('html').attr('dir') === 'rtl'? [
          '<i class="fas fa-chevron-right"></i>',
          '<i class="fas fa-chevron-left"></i>',
        ] : [
          '<i class="fas fa-chevron-left"></i>',
          '<i class="fas fa-chevron-right"></i>',
        ],
        rtl: $('html').attr('dir') === 'rtl',
        responsive: {
          0: {
            items: 1,
          },
          400: {
            items: 2,
          },
          767: {
            items: 3,
          },
          991: {
            items: 4,
          },
          1199: {
            items: 3,
          },
          1399: {
            items: 4,
          },
          1499: {
            items: 4,
          },
          1699: {
            items: 4,
          },
        },
      });
    };

    // Initialize the carousel on mount
    onMounted(() => {
      nextTick(() => {
        initializeCarousel();
      });
    });

    // Watch for changes in the `items` prop and reinitialize the carousel if necessary
    watch(
      () => props.items,
      (newItems, oldItems) => {
        if (newItems !== oldItems) {
          nextTick(() => {
            initializeCarousel();
          });
        }
      }
    );

    // Cleanup on unmount to prevent memory leaks
    onBeforeUnmount(() => {
      destroyCarousel();
    });

    return {
      owlCarousel,
    };
  },
};
</script>
